import Footer from '../../footer/Footer';
import Navbar from '../../navbar/Navbar';
import AboutLeftTab from '../../About/AboutLeftTab';


function CloudComputingWorkshop() {
    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />

                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="col-lg-12 ps-lg-4">
                                <div className="how-to-apply">
                                    <h2 className='pb-2'>
                                        IT Dept conducted a Two day workshop on cloud computing 22nd and 23rd August 2025
                                    </h2>

                                    <div class="css-script-ads" >
                                    </div>
                                    <div class="spotlight-group">
                                        <div class="row">
                                            <div class="col-md-6 mb-3 mb-lg-4">
                                                <a class="spotlight" href="https://admin.swec.ac.in/assetsswec/img/cloud-computing/day-1-two-day-workshop-on-cloud-computing-tools-1.jpeg">
                                                    <img src="https://admin.swec.ac.in/assetsswec/img/cloud-computing/day-1-two-day-workshop-on-cloud-computing-tools-1.jpeg" loading="lazy" alt="Day 1 - Two Day Workshop on Cloud Computing Tools" class="img-responsive center-block rounded-1" />
                                                </a>
                                            </div>

                                            <div class="col-md-6 mb-3 mb-lg-4">
                                                <a class="spotlight" href="https://admin.swec.ac.in/assetsswec/img/cloud-computing/day-1-two-day-workshop-on-cloud-computing-tools.jpeg">
                                                    <img src="https://admin.swec.ac.in/assetsswec/img/cloud-computing/day-1-two-day-workshop-on-cloud-computing-tools.jpeg" loading="lazy" alt="Day 1 - Two Day Workshop on Cloud Computing Tools" class="img-responsive center-block rounded-1" />
                                                </a>
                                            </div>

                                            <div class="col-md-6 mb-3 mb-lg-4">
                                                <a class="spotlight" href="https://admin.swec.ac.in/assetsswec/img/cloud-computing/day-2-session-workshop-on-cloud-computing-tools.jpeg">
                                                    <img src="https://admin.swec.ac.in/assetsswec/img/cloud-computing/day-2-session-workshop-on-cloud-computing-tools.jpeg" loading="lazy" alt="Day 2 Session - Workshop on Cloud Computing Tools" class="img-responsive center-block rounded-1" />
                                                </a>
                                            </div>

                                            <div class="col-md-6 mb-3 mb-lg-4">
                                                <a class="spotlight" href="https://admin.swec.ac.in/assetsswec/img/cloud-computing/day-2-session-workshop-on-cloud-computing-tools-1.jpeg">
                                                    <img src="https://admin.swec.ac.in/assetsswec/img/cloud-computing/day-2-session-workshop-on-cloud-computing-tools-1.jpeg" loading="lazy" alt="Day 2 Session - Workshop on Cloud Computing Tools" class="img-responsive center-block rounded-1" />
                                                </a>
                                            </div>

                                            <div class="col-md-6 mb-3 mb-lg-4">
                                                <a class="spotlight" href="https://admin.swec.ac.in/assetsswec/img/cloud-computing/1.jpg">
                                                    <img src="https://admin.swec.ac.in/assetsswec/img/cloud-computing/1.jpg" loading="lazy" alt="Day 2 Session - Workshop on Cloud Computing Tools" class="img-responsive center-block rounded-1" />
                                                </a>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Footer />
        </div>
    )
}

export default CloudComputingWorkshop
